﻿import browserBack from './lib/browserBack.js';
import ContentPopup from './lib/content-popup';
import FormEvents from './lib/form-events';
import FormValidation from './lib/form-validation';
import Select from './lib/select';
import Tooltips from './lib/tooltips';
import Steps from './lib/steps';
import Accordion from './lib/accordion';

class App {
    constructor() {
        this.dom = {
            $: window.$,
            $window: $(window),
            $body: $('body')
        };

        if (this.dom.$body.find('form').length) {
            this.init();
        }
    }

    init() {
        new ContentPopup();
        new FormEvents();
        new FormValidation();
        new Select();
        new Tooltips();
        new Steps();
        new Accordion();
    }
}

document.addEventListener('DOMContentLoaded', () => new App());
